import Sidebar from './sidebar-component';
import SidebarService from './sidebar-service';

const MODULE_NAME = 'App.Main.Sidebar';
const module = angular
    .module(MODULE_NAME, [])
    .directive('ktSidebar', Sidebar)
    .service('sidebarService', SidebarService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/main/sidebar/sidebar-module.js